const APPOINTMENTS_VIEW = 'my-account/datalayer/appointments-view';
const UPCOMING_APPOINTMENT_VIEW = 'my-account/datalayer/upcoming-appointment-view';
const RESCHEDULE_APPOINTMENT = 'my-account/datalayer/reschedule-appointment';
const appointmentsView = (appointments)=>({
        type: APPOINTMENTS_VIEW,
        payload: {
            appointments
        }
    })
;
const upcomingAppointmentView = (appointment)=>({
        type: UPCOMING_APPOINTMENT_VIEW,
        payload: {
            appointment
        }
    })
;
const rescheduleAppointment = (appointment)=>({
        type: RESCHEDULE_APPOINTMENT,
        payload: {
            appointment
        }
    })
;

export { APPOINTMENTS_VIEW, RESCHEDULE_APPOINTMENT, UPCOMING_APPOINTMENT_VIEW, appointmentsView, rescheduleAppointment, upcomingAppointmentView };
//# sourceMappingURL=actions.js.map
